import { clone, EConfirmationOperationType, IAction, IComponentIdHolder, IControl, ISharedJourney } from '../../helpers';
import types from '../types';

interface IConfirmationDialogState {
	operationType: EConfirmationOperationType;
	title: string;
	message: string;
	isOpen: boolean;
	okButtonLabel?: string;
	cancelButtonLabel?: string;
	isCancelButtonHidden?: boolean;
	actionType?: string;
	actionEntity?: string;
	componentId?: string;
	branchIndex?: number;
	controlIndex?: number;
	controlId?: string;
	outputs?: any;
	deletedComponentId?: string,
	newNextComponent?: IComponentIdHolder,
	firstLoopComponentId?: string,
	action?: IControl | IAction | ISharedJourney,
	deletedOutputs?: string[],

	openModal?: number,
	componentModal?: number,
	modalStateComponentId?: string;
	previousOutputBlocks?: string[],

	panelName?: string;
	journeyEngineSettingsId?: string;
	layoutPanelIndex?: number,
	replaceGuids?: boolean,
	saveAndResume?: boolean,

}

const initialState: IConfirmationDialogState = {
	operationType: EConfirmationOperationType.DeleteDecision,
	title: '',
	message: '',
	isOpen: false,
	okButtonLabel: 'OK',
	cancelButtonLabel: 'Cancel',
	isCancelButtonHidden: false,
	actionType: null,
	actionEntity: null,
	componentId: null,
	branchIndex: null,
	controlIndex: null,
	outputs: null,
	deletedComponentId: null,
	newNextComponent: null,
	firstLoopComponentId: null,
	action: null,
	deletedOutputs: [],

	openModal: null,
	componentModal: null,
	modalStateComponentId: null,
	previousOutputBlocks: [],

	panelName: '',
	journeyEngineSettingsId: '',
	layoutPanelIndex: null,
	replaceGuids: false,
	saveAndResume: false


};

const confirmationDialogReducer = function (state: IConfirmationDialogState = initialState, action) {

	let stateClone: IConfirmationDialogState = clone(state);

	switch (action.type) {

		case types.TOGGLE_CONFIRMATION_DIALOG:
			stateClone = toggleConfirmationDialog(stateClone, action.operationType, action.title, action.message, action.isOpen,
				action.okButtonLabel, action.cancelButtonLabel, action.isCancelButtonHidden, action.actionType, action.actionEntity, action.componentId, action.branchIndex,
				action.controlIndex, action.controlId, action.outputs, action.deletedComponentId, action.newNextComponent, action.firstLoopComponentId,
				action.action, action.deletedOutputs,
				state.openModal,
				state.componentModal,
				state.modalStateComponentId,
				state.previousOutputBlocks,
				state.panelName,
				state.journeyEngineSettingsId,
				action.layoutPanelIndex,
				action.replaceGuids,
				action.saveAndResume
			);
			break;

	}

	return stateClone;

};

let toggleConfirmationDialog = (
	state: IConfirmationDialogState, operationType: EConfirmationOperationType, title: string, message: string, isOpen: boolean, okButtonLabel: string,
	cancelButtonLabel: string, isCancelButtonHidden: boolean, actionType: string, actionEntity: string, componentId: string, branchIndex: number, controlIndex: number, controlId: string, outputs: any,
	deletedComponentId: string, newNextComponent: IComponentIdHolder, firstLoopComponentId: string, action: IControl | IAction | ISharedJourney, deletedOutputs: string[],
	openModal: number, componentModal: number, modalStateComponentId: string, previousOutputBlocks: string[], panelName: string, journeyEngineSettingsId: string, layoutPanelIndex: number,
	replaceGuids: boolean, saveAndResume: boolean

): IConfirmationDialogState => {

	state.operationType = operationType;
	state.title = title || initialState.title;
	state.message = message || initialState.message;
	state.isOpen = isOpen;
	state.okButtonLabel = okButtonLabel || initialState.okButtonLabel;
	state.cancelButtonLabel = cancelButtonLabel || initialState.cancelButtonLabel;
	state.isCancelButtonHidden = isCancelButtonHidden || initialState.isCancelButtonHidden;
	state.actionType = actionType;
	state.actionEntity = actionEntity;
	state.componentId = componentId;
	state.branchIndex = branchIndex;
	state.controlIndex = controlIndex;
	state.controlId = controlId;
	state.outputs = outputs;
	state.deletedComponentId = deletedComponentId;
	state.newNextComponent = newNextComponent;
	state.firstLoopComponentId = firstLoopComponentId;
	state.action = action;
	state.deletedOutputs = deletedOutputs;
	state.openModal = openModal;
	state.componentModal = componentModal;
	state.modalStateComponentId = modalStateComponentId;
	state.previousOutputBlocks = previousOutputBlocks;
	state.panelName = panelName;
	state.journeyEngineSettingsId = journeyEngineSettingsId;
	state.layoutPanelIndex = layoutPanelIndex;
	state.replaceGuids = replaceGuids;
	state.saveAndResume = saveAndResume;

	return state;
};

export default confirmationDialogReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/confirmation-dialog.ts